

export const HARDCODED_PACK_TYPES = [
    {
        id: 'מ',
        name: 'מיכל'
    },
    {
        id: 'ק',
        name: 'קרטון'
    },
    {
        id: 'פ',
        name: 'פלאו'
    },
    {
        id: 'ד',
        name: 'דלי'
    },
    {
        id: 'א',
        name: 'אביזר נלווה'
    },
    {
        id: '1',
        name: 'ק״ג'
    },
    {
        id: '2',
        name: 'יחידות'
    },
    {
        id: '3',
        name: 'ארגז פלסטיק'
    }
]